import { createSelector } from '@ngrx/store';
import { EntityStoreFactory, IGenericEntityState } from '@pit/core-store';
import { DtoShipmentReturnCode, IDtoShipmentReturnCode } from '@pit/frontend-model';

export class DtoShipmentReturnCodeStoreFactory extends EntityStoreFactory<IDtoShipmentReturnCode> {

    private static _instance: DtoShipmentReturnCodeStoreFactory = null;

    public static get instance(): DtoShipmentReturnCodeStoreFactory {
        if (this._instance === null) {
            this._instance = new DtoShipmentReturnCodeStoreFactory();
        }

        return this._instance;
    }

    constructor() {
        super('DtoShipmentReturnCode', 'dto.shipment.return.code');
    }

    protected override doCreateActions(): void {
        super.doCreateActions();
    }

    protected override doCreateEffects(): void {
        super.doCreateEffects();
    }

    protected override doCreateSelectors() {
        super.doCreateSelectors();

        this.entitySelectors.add('get.by.code', (code: string) => createSelector(
            this.getSelector('get.all.entities'),
            (items: IDtoShipmentReturnCode[]) => items.find(x => (x.code === code))
        ));
    }

    protected override doGetReducers<S extends IGenericEntityState<IDtoShipmentReturnCode>>(): any {
        const result: any = super.doGetReducers();

        return result;
    }

}
